// fullFaceBotoxData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    keywords?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
    relatedTreatments?: {
        en: string;
        ar: string;
        href: string;
        image: string;
    }[];
    treatments?: {
        heading?: string;
        subheading?: string;
        items: {
            en: string;
            ar: string;
            href: string;
        }[];
    };
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const underArmBotox: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} = {
    shared: {
        images: {
            introductionImage: '',
            main: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/ebh-services-uae-3-scaled.jpg",
            beforeAfter: []
        },
        product: {
            id: 2,
            title: "Underarm Botox Treatment",
            price: 299,
            description: "Clinically proven Botox treatment for underarms to reduce excessive sweating (hyperhidrosis) and boost confidence."
        }
    },
    "en": {
        "url": "underarm-botox-treatment-dubai",
        "meta": {
            "title": "Underarm Botox Treatment in Dubai",
            "description": "Tired of having to worry about underarm sweat stains and smells all the time? Armpit Botox treatment is a quick and effective way to combat excessive sweating (hyperhidrosis) and regain your confidence.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Underarm Botox Dubai"],
        "hero": {
            "title": "Underarm Botox Treatment in Dubai",
            "subtitle": "",
            "description": "Tired of having to worry about underarm sweat stains and smells all the time? Armpit Botox treatment is a quick and effective way to combat excessive sweating (hyperhidrosis) and regain your confidence. Botox Injections at Elite Body Home Polyclinic Dubai to keep you dry and comfortable"
        },
        "howItWorks": {
            "title": "What is Underarm Botox?",
            "description": "An underarm Botox injection is a noninvasive procedure that blocks the sweat-producing nerves for a temporary period. A few injections and wow long-lasting relief from excessive sweating. The process takes a short time and causes little to no discomfort, The procedure is quick, with minimal discomfort, and results can last for up to 6 months."
        },
        "procedureSteps": {
            "heading": "Botox Underarm Treatment Procedure Steps",
            "para": "Hyperhidrosis underarm Botox is an effective treatment designed to reduce excessive sweating by targeting the nerves that control sweat glands.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Before the treatment, you'll speak with a specialist to discuss your excessive sweating concerns and decide if underarm Botox is the right path for you.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Preparation",
                    "desc": "The treatment area (underarms) will be cleaned, and a numbing cream or ice pack applied to reduce any discomfort from the injections.",
                    "icon": "fa-solid fa-soap"
                },
                {
                    "title": "Marking the Treatment Area",
                    "desc": "A doctor uses a marker or a starch-iodine test to locate the most active sweat glands, which ensures you get the injections precisely where you need them.",
                    "icon": "fa-solid fa-pen-ruler"
                },
                {
                    "title": "Session Duration",
                    "desc": "Using a fine needle, small doses of Botox will be injected into multiple points in each underarm. This typically requires 10-15 injections per underarm.",
                    "icon": "fa-solid fa-stopwatch"
                }
            ]
        },
        "benefits": {
            "heading": "Key Benefits of Underarm Botox Treatment",
            "subheading": "",
            "para": "Underarm Botox treatment has emerged as a highly effective solution for individuals struggling with hyperhidrosis, or excessive sweating. This FDA-approved procedure not only offers relief from uncomfortable sweating but also brings a host of other benefits that can improve a person's quality of life. Here, we explore the key advantages of opting for Botox treatment to manage underarm hyperhidrosis.",
            "items": [
                {
                    "title": "Significant Reduction in Sweating",
                    "desc": "Botox blocks the nerve signals that tell your body to produce sweat, significantly limiting excessive sweating in the process. Treated patients typically see improvement within days.",
                    "icon": "fa-solid fa-droplet-slash"
                },
                {
                    "title": "Long-Lasting Results",
                    "desc": "The long-term benefits of Botox for hyperhidrosis are one of its greatest advantages. Results usually last between 4 to 12 months, providing years of enjoyment in sweat-free comfort before going back for another session.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Improves Quality of Life",
                    "desc": "Sweating too much can cause stress in social life. Having Botox treatment can boost a person's self-esteem immensely, allowing them to take part in daily activities without the concern of sweat stains or odor.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Non-Surgical & Minimally Invasive",
                    "desc": "Some signs of concern, however, can include: In addition, Botox treatment for underarm sweating is a quick, outpatient procedure. With little to no downtime and no need for surgery, it is certainly appealing to those who live on a busy schedule.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Minimal Side Effects",
                    "desc": "The treatment has a long-established safety record with minimal side effects. Common side effects include mild bruising or tenderness at the injection site, both of which pass quickly. It's a relatively low-risk measure with few serious side effects.",
                    "icon": "fa-solid fa-shield-heart"
                },
                {
                    "title": "Boosts Comfort & Hygiene",
                    "desc": "Excessive sweating may cause skin irritation and bad odor. I didn't just use the Botox to reduce sweat but kept my hygiene and skin healthy by preventing build up of moisture in my underarms.",
                    "icon": "fa-solid fa-hand-holding-water"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from Underarm Botox Treatment?",
            "subheading": "",
            "para": "Underarm Botox, or Botox for hyperhidrosis (excessive sweating), is typically appropriate for people who:",
            "items": [
                {
                    "title": "People with Hyperhidrosis",
                    "desc": "Botox is primarily designed for individuals diagnosed with hyperhidrosis, a condition characterized by excessive sweating that is not related to heat or physical activity. If you find that you sweat excessively, even in cool conditions, you may benefit from Botox injections.",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "People Who Suffer from Daily Discomfort from Pressing Advanced Articles",
                    "desc": "If excessive underarm sweating is interfering with your daily activities, social interactions, or causing embarrassment, you could be a good candidate for underarm Botox. The treatment helps reduce sweating significantly, allowing you to regain confidence and comfort.",
                    "icon": "fa-solid fa-face-frown"
                },
                {
                    "title": "People Unresponsive to Other Treatments",
                    "desc": "Many individuals have tried various antiperspirants, prescription-strength deodorants, or other over-the-counter solutions with little success. Botox offers an alternative for those who haven't found relief from these more conventional treatments.",
                    "icon": "fa-solid fa-circle-xmark"
                },
                {
                    "title": "Patients Seeking a Non-Surgical Solution",
                    "desc": "Underarm Botox is an excellent option for people looking for a non-invasive procedure. Since it does not require surgery and has minimal downtime, it appeals to those who prefer an easy, low-risk treatment option for hyperhidrosis.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "People Seeking Temporary Relief from Sweating",
                    "desc": "For those who prefer a temporary solution rather than permanent treatment, Botox is ideal. The effects typically last between 4 to 12 months, providing long-term relief without committing to a more invasive option.",
                    "icon": "fa-solid fa-clock-rotate-left"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "Preparing for Your Underarm Botox Treatment: Tips for Best Results",
            "para": "While this innovative treatment is highly effective for excessive sweating, there are a few steps you can take to prepare for the appointment which will ensure you get the best results. Here are some key advice to make sure you have a smooth experience and optimal results.",
            "items": [
                {
                    "title": "Schedule a Consultation",
                    "desc": "Seek advice from a qualified medical professional to evaluate your condition and make sure you are a suitable candidate for the procedure. This step helps manage expectations and provides personalized advice.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Avoid Shaving",
                    "desc": "Skip your underarm shaving 24 to 48 hours before the treatment to prevent skin irritation and decrease sensitivity during injections.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "Avoid Blood-Thinning Medications",
                    "desc": "To help reduce your chances of bruising, skip blood thinners like aspirin or ibuprofen for a few days leading up to your appointment, unless your doctor instructs you otherwise.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Limit Alcohol",
                    "desc": "Do not drink any alcohol for 24 hours before the procedure, as this will increase bruising.",
                    "icon": "fa-solid fa-wine-bottle"
                },
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "On the day of your treatment, wear loose-fitting, breathable clothing that allows the technician access to the underarms easily, and doesn't risk irritation following the treatment.",
                    "icon": "fa-solid fa-shirt"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink lots and lots of water leading to your appointment, for both overall skin health and for a faster recovery!",
                    "icon": "fa-solid fa-glass-water"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "Achieving Your Expected Results from Underarm Botox Treatment",
            "para": "Understanding the results you can expect from the procedure is essential to fully appreciate its benefits and longevity. Below, we outline what you can anticipate in terms of outcomes, recovery, and overall effectiveness.",
            "items": [
                {
                    "title": "Immediate and Gradual Results",
                    "desc": "Most patients can observe a decrease in underarm sweating from 2 to 4 days post-treatment. But full effects usually take one to two weeks.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Long-Lasting Relief",
                    "desc": "Botox effects in the underarm area can last a long time and the reduction in sweating lasts in most patients 4 to 12 months. The time frame might differ based on the person.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Improved Quality of Life",
                    "desc": "As you sweat less with underarm Botox, you will feel a lot more comfortable in your day-to-day life, more confident, and enjoy socializing!",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Minimal Side Effects",
                    "desc": "The vast majority of patients experience few, if any, side effects, like slight redness or tenderness where they were injected. These symptoms usually go away in a few days.",
                    "icon": "fa-solid fa-star"
                }
            ]
        },

        "aftercareTips": {
            "heading": "Aftercare Tips for Underarm Botox",
            "subheading": "",
            "para": "Proper aftercare ensures the longevity of your results and minimizes any potential side effects. Following these aftercare guidelines will help you achieve the best outcomes from your underarm Botox treatment.",
            "items": [
                {
                    "title": "Do not get things wet",
                    "desc": "Keep the armpits dry for the next 48 hours. The right aftercare guarantees that your results can last as long as possible and that side effects are reduced.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "Avoid Touching the Area",
                    "desc": "Do not rub or massage the treated areas, nor apply any pressure for the first 24-48 hours. This helps stop Botox from migrating to other muscles where it wasn't intended.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "Stay Away from Heat",
                    "desc": "Do not expose yourself to heat sources including hot showers, saunas, and steam rooms for at least 24-48 hours after treatment. Heat increases blood flow, which can lead to migration of the Botox.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "Limit Physical Activity",
                    "desc": "Do not perform strenuous exercise or anything that may result in sweating for the first 24 hours. As such, engaging in physical activity can raise body temperature and interfere with the effectiveness of the Botox treatment.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "Avoid Antiperspirants for 24 Hours",
                    "desc": "For at least 24 hours to avoid further irritation, do not apply any antiperspirants/deodorants or other products that could further irritate the treated areas.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "No Alcohol Consumption",
                    "desc": "Avoid alcoholic beverages for at least 24 hours after treatment. Alcohol can raise the risk of bruising, and possibly the result of the Botox.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "Monitor for Side Effects",
                    "desc": "Some mild redness, swelling or bruising around the injection sites is normal. But if you have extreme pain, prolonged swelling or signs of infection, call your provider right away.",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "If you're considering Underarm Botox Treatment in Dubai, you may have several questions about the procedure, its effectiveness, and what to expect. Here are some of the most frequently asked questions to help you make an informed decision.",
            "items": [
                {
                    "question": "What is Botox and how does it stop the underarm sweating?",
                    "answer": "Botox works by blocking the chemical signals from the nerves that tell the sweat glands to produce sweat. This reduces the activity of the sweat glands, leading to less sweat production."
                },
                {
                    "question": "Is underarm Botox safe?",
                    "answer": "Yes, underarm Botox is FDA-approved and considered safe for treating hyperhidrosis. Side effects are typically minimal, such as slight bruising or temporary discomfort at the injection site."
                },
                {
                    "question": "How long does the process take?",
                    "answer": "The underarm Botox procedure usually takes about 15-20 minutes and involves multiple small injections in each underarm."
                },
                {
                    "question": "How long do the results last?",
                    "answer": "The effects of underarm Botox typically last 4 to 6 months. After that, you can schedule follow-up treatments to maintain the results."
                },
                {
                    "question": "Does the treatment hurt?",
                    "answer": "The injections are generally well-tolerated, with minimal discomfort. Some patients compare it to a small pinprick. Numbing cream or ice can be applied before treatment to enhance comfort."
                },
                {
                    "question": "Do I need to take any time off after the treatment?",
                    "answer": "There is no downtime with underarm Botox. You can resume normal activities immediately after the procedure, though you may be advised to avoid intense physical activity for 24 hours."
                },
                {
                    "question": "What is the cost of underarm Botox?",
                    "answer": "The cost of underarm Botox varies depending on the clinic and the amount of Botox needed. It's best to consult with your provider for a detailed cost estimate."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },

    "ar": {
        "url": "underarm-botox-treatment-dubai",
        "meta": {
            "title": "حقن البوتوكس تحت الإبط في دبي",
            "description": "هل سئمت من القلق المستمر بشأن بقع العرق ورائحته؟ يعد بوتوكس تحت الإبط علاجًا سريعًا وفعالًا للتخلص من التعرق الزائد (فرط التعرق) واستعادة ثقتك بنفسك.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "بوتوكس تحت الإبط دبي"],
        "hero": {
            "title": "حقن البوتوكس تحت الإبط في دبي",
            "subtitle": "",
            "description": "هل سئمت من القلق المستمر بشأن بقع العرق ورائحته؟ يعد بوتوكس تحت الإبط علاجًا سريعًا وفعالًا للتخلص من التعرق الزائد (فرط التعرق) واستعادة ثقتك بنفسك. نقدم في عيادة إيليت بودي هوم في دبي حقن البوتوكس للتعرق ليمنحك إحساسًا دائمًا بالجفاف والراحة."
        },
        "howItWorks": {
            "title": "ما هو بوتوكس تحت الإبط؟",
            "description": "يُعد بوتوكس تحت الإبط إجراء غير جراحي يعمل على تعطيل مؤقت للإشارات العصبية المسؤولة عن تحفيز الغدد العرقية. تمنحك بضع حقن بسيطة راحة طويلة الأمد من التعرق المفرط. تستغرق العملية وقتًا قصيرًا مع حد أدنى من الألم، وتدوم النتائج حتى 6 أشهر."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء بوتوكس تحت الإبط",
            "para": "صُمم علاج فرط التعرق بالبوتوكس لتعطيل الإشارات العصبية المسؤولة عن تحفيز الغدد العرقية مؤقتًا.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "ستلتقي بالطبيب المتخصص قبل العلاج لمناقشة مشكلة التعرق الزائد، وتحديد ما إذا كان البوتوكس تحت الإبط هو العلاج الملائم لك.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف المنطقة المعالجة (تحت الإبط)، ثم يُستخدم كريم مخدر أو كمادات باردة لتقليل الشعور بالألم أثناء الحقن.",
                    "icon": "fa-solid fa-soap"
                },
                {
                    "title": "تحديد منطقة العلاج",
                    "desc": "يستخدم الطبيب قلم تحديد أو يُجري اختبار النشا واليود لتحديد أكثر الغدد العرقية نشاطًا، مما يضمن دقة الحقن في الأماكن المناسبة.",
                    "icon": "fa-solid fa-pen-ruler"
                },
                {
                    "title": "مدة الجلسة",
                    "desc": "تُحقن كميات صغيرة جدًا من البوتوكس باستخدام إبرة دقيقة في نقاط متعددة تحت كل إبط. يحتاج كل إبط من 10 إلى 15 حقنة لتحقيق نتائج فعالة.",
                    "icon": "fa-solid fa-stopwatch"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد حقن البوتوكس تحت الإبط",
            "subheading": "",
            "para": "أصبح بوتوكس تحت الإبط من أفضل الحلول لعلاج فرط التعرق، حيث يُعتبر علاجًا فعالًا ومعتمدًا من إدارة الغذاء والدواء الأمريكية (FDA) لتقليل التعرق الزائد وتحسين جودة الحياة. إليك بعض الفوائد المهمة لهذا العلاج:",
            "items": [
                {
                    "title": "تقليل التعرق بشكل كبير",
                    "desc": "يعمل البوتوكس على منع الإشارات العصبية التي تحفز الغدد العرقية، مما يقلل التعرق المفرط بشكل ملحوظ. يبدأ المرضى في ملاحظة التحسن خلال أيام قليلة بعد الجلسة.",
                    "icon": "fa-solid fa-droplet-slash"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تُعد المدة الطويلة لفعالية العلاج من أكبر مزايا بوتوكس فرط التعرق، حيث تستمر النتائج عادةً من 4 إلى 12 شهرًا، مما يمنح راحة طويلة الأمد دون الحاجة لجلسات متكررة.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "تحسين جودة الحياة",
                    "desc": "يمكن أن يكون التعرق الزائد مصدرًا للقلق والإحراج في الحياة الاجتماعية. يساعد علاج بوتوكس تحت الإبط في تعزيز الثقة بالنفس، مما يسمح لك بالمشاركة في الأنشطة اليومية دون القلق من بقع العرق أو الروائح الكريهة.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "إجراء غير جراحي وسريع",
                    "desc": "يتم العلاج في جلسة سريعة ودون تدخل جراحي، ولا يتطلب فترة تعافي، مما يجعله مثاليًا للأشخاص ذوي جدول الأعمال المزدحم.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "يُعرف بوتوكس تحت الإبط بأنه إجراء آمن، حيث أن آثاره الجانبية قليلة جدًا، وتقتصر على احتمالية ظهور كدمات خفيفة أو احمرار في موقع الحقن، وتختفي سريعًا.",
                    "icon": "fa-solid fa-shield-heart"
                },
                {
                    "title": "تعزيز الراحة والنظافة الشخصية",
                    "desc": "يساعد تقليل التعرق في منع تهيج الجلد والروائح الكريهة، مما يحافظ على نظافة البشرة وصحتها عن طريق تقليل تراكم الرطوبة تحت الإبط.",
                    "icon": "fa-solid fa-hand-holding-water"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المثالي لبوتوكس تحت الإبط؟",
            "subheading": "",
            "para": "يُعد بوتوكس تحت الإبط (أو بوتوكس فرط التعرق) خيارًا مثاليًا:",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من فرط التعرق",
                    "desc": "يُستخدم بوتوكس تحت الإبط لمن يعاني من التعرق المفرط، سواء بسبب ارتفاع الحرارة أو النشاط البدني أو التعرق بشكل مفرط في الأجواء الباردة، فقد تكون مرشحًا جيدًا لهذا العلاج.",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "الأشخاص الذين يعانون من الإنزعاج يوميًا بسبب التعرق الزائد",
                    "desc": "إذا كان التعرق الزائد يؤثر على حياتك اليومية، أو يُسبب لك الإحراج في حياتك الاجتماعية، فقد يكون بوتوكس تحت الإبط الحل المناسب. هذا العلاج يقلل التعرق بشكل كبير، مما يساعدك على الشعور بالراحة والثقة بالنفس.",
                    "icon": "fa-solid fa-face-frown"
                },
                {
                    "title": "الأشخاص الذين لم يستجيبوا للعلاجات الأخرى",
                    "desc": "إذا كنت قد جربت مزيلات العرق القوية أو العلاج الموضعي دون الحصول على نتائج مرضية، فقد يكون البوتوكس بديلاً فعالًا.",
                    "icon": "fa-solid fa-circle-xmark"
                },
                {
                    "title": "المرضى الذين يبحثون عن حل غير جراحي",
                    "desc": "يُعد بوتوكس تحت الإبط علاج مثالي لمن يبحث عن إجراء غير جراحي ولا يتطلب فترة تعافي، يجذب المرضى الذين يبحثون عن علاج سهل وغير خطر لفرط التعرق.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "الأشخاص الذين يرغبون في تقليل التعرق لمدة طويلة",
                    "desc": "يعتبر البوتوكس خيارًا رائعًا لمن يرغب في علاج بسيط يستمر لمدة مناسبة، حيث يوفر راحة طويلة الأمد لمدة تتراوح بين 4 إلى 12 شهرًا، مع إمكانية إعادة الجلسة حسب الحاجة.",
                    "icon": "fa-solid fa-clock-rotate-left"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "التحضير لجلسة بوتوكس تحت الإبط: نصائح للحصول على أفضل النتائج",
            "para": "توجد بعض التحضيرات التي يمكنك القيام بها قبل الموعد لضمان الحصول على أفضل نتائج وتجربة مريحة. إليك أهم النصائح للتحضير للجلسة:",
            "items": [
                {
                    "title": "تحديد موعد استشارة",
                    "desc": "قم باستشارة طبيب متخصص لتقييم حالتك والتأكد من أنك مرشح مناسب للعلاج، مما سيساعدك على التخطيط السليم واتخاذ القرار المناسب.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "تجنب الحلاقة قبل الجلسة",
                    "desc": "يُفضل عدم حلاقة تحت الإبط لمدة 24 إلى 48 ساعة قبل الجلسة، وذلك لتجنب التهاب البشرة وتقليل الحساسية أثناء الحقن.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "تجنب الأدوية المميعة للدم",
                    "desc": "تجنب تناول أدوية مميعة للدم مثل الأسبرين أو الإيبوبروفين قبل موعد الجلسة بعدة أيام للمساعدة في تقليل خطر الكدمات، ما لم يوصي الطبيب بخلاف ذلك.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الامتناع عن شرب الكحول",
                    "desc": "تجنب المشروبات الكحولية لمدة 24 ساعة على الأقل قبل العلاج، لأن الكحول يزيد من احتمالية ظهور الكدمات.",
                    "icon": "fa-solid fa-wine-bottle"
                },
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "ارتدي ملابس فضفاضة وخفيفة في يوم الجلسة، لتتيح سهولة الوصول إلى منطقة تحت الإبط وتجنب الاحتكاك أو التهاب الجلد بعد العلاج.",
                    "icon": "fa-solid fa-shirt"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "احرص على شرب كميات كافية من الماء قبل الجلسة، حيث يساعد ترطيب الجسم على تحسين صحة البشرة وتسريع عملية التعافي.",
                    "icon": "fa-solid fa-glass-water"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "بوتوكس تحت الإبط لتحقيق نتائج مريحة",
            "para": "يساعد فهمك المسبق لنتائج العلاج ومدته على تقدير مزاياه بشكل كامل والاستمتاع بتجربة ناجحة. إليك ما يمكن توقعه من حيث النتائج وفترة التعافي وفعالية العلاج:",
            "items": [
                {
                    "title": "نتائج فورية وتدريجية",
                    "desc": "يبدأ معظم المرضى بملاحظة انخفاض في التعرق خلال 2 إلى 4 أيام بعد العلاج، بينما تظهر النتائج الكاملة في غضون أسبوع إلى أسبوعين عادةً.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "راحة تدوم طويلًا",
                    "desc": "يستمر تأثير البوتوكس في منطقة تحت الإبط من 4 إلى 12 شهرًا، وفقًا لطبيعة الجسم واستجابته للعلاج.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "تحسين جودة الحياة",
                    "desc": "ستشعر براحة أكبر وثقة أعلى في حياتك اليومية مع علاج فرط التعرق، مما يعزز شعورك بالراحة أثناء التفاعل الاجتماعي والاستمتاع بالأنشطة دون قلق.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "لا يعاني معظم المرضى من آثار جانبية ملحوظة، ولكن قد يواجه البعض احمرارًا طفيفًا أو حساسية في مواضع الحقن، لكنها عادةً تزول خلال أيام قليلة.",
                    "icon": "fa-solid fa-star"
                }
            ]
        },
        "aftercareTips": {
            "heading": "إرشادات العناية بعد العلاج",
            "subheading": "",
            "para": "يُفضل الالتزام بتعليمات العناية بعد العلاج للحفاظ على النتائج لأطول فترة ممكنة ولضمان أقصى استفادة من العلاج وتقليل الآثار الجانبية. إليك اهم الإرشادات:",
            "items": [
                {
                    "title": "حافظ على جفاف المنطقة المُعالجة",
                    "desc": "تجنب تبلل منطقة تحت الإبط خلال أول 48 ساعة بعد العلاج، لضمان أفضل النتائج وتقليل احتمالية ظهور التهابات.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "تجنّب لمس المنطقة المُعالجة",
                    "desc": "لا تفرك أو تضغط على منطقة تحت الإبط لمدة 24 إلى 48 ساعة، لمنع انتقال البوتوكس إلى مناطق أخرى غير مستهدفة.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "تجنب التعرض للحرارة",
                    "desc": "تجنب الاستحمام بالماء الساخن و تجنب الساونا وغرف البخار لمدة لا تقل عن 24 إلى 48 ساعة بعد العلاج. حيث تؤدي الحرارة إلى زيادة تدفق الدم، مما قد يؤثر على استقرار البوتوكس.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "تجنب النشاط البدني المكثف",
                    "desc": "يفضل الامتناع عن ممارسة التمارين الشاقة أو الأنشطة التي قد تسبب التعرق خلال أول 24 ساعة، حيث يمكن أن تؤدي زيادة حرارة الجسم إلى تقليل فعالية علاج البوتوكس.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "تجنب استخدام مضادات التعرق",
                    "desc": "تجنب استخدام مزيلات ومضادات التعرق أو أي منتجات أخرى تحت الإبط لمدة 24 ساعة بعد العلاج، لمنع حدوث التهاب إضافي في المنطقة المعالجة.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "الامتناع عن شرب الكحول",
                    "desc": "يُفضل الامتناع عن المشروبات الكحولية لمدة 24 ساعة بعد الجلسة، حيث يمكن أن تزيد من احتمالية التورم أو الكدمات، مما قد يؤثر على نتائج العلاج.",
                    "icon": "fa-solid fa-water"
                },
                {
                    "title": "مراقبة الآثار الجانبية",
                    "desc": "يُعد من الطبيعي حدوث احمرار طفيف أو تورم أو كدمات خفيفة حول مواضع الحقن، لكنها تختفي تدريجيًا خلال أيام قليلة. لكن يجب إبلاغ الطبيب على الفور إذا شعرت بألم شديد، أو تورم مستمر، أو علامات للعدوى.",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "أصبحت دبي الوجهة المفضلة لمن يبحث عن علاج البوتوكس لمنطقة تحت الإبط. فيما يلي بعض الأسئلة الشائعة لمساعدتك في اتخاذ قرار مستنير:",
            "items": [
                {
                    "question": "ما هو البوتوكس وكيف يوقف التعرق تحت الإبط؟",
                    "answer": "يعمل البوتوكس عن طريق تعطيل مؤقت للإشارات العصبية المسؤولة عن تحفيز الغدد العرقية على إنتاج العرق. يؤدي ذلك إلى تقليل نشاط الغدد، مما يحد من إفراز العرق."
                },
                {
                    "question": "هل يعد بوتوكس تحت الإبط آمنًا؟",
                    "answer": "نعم، حيث أن البوتوكس لمنطقة تحت الإبط معتمد من قبل إدارة الغذاء والدواء الأمريكية (FDA) ويعتبر آمنًا لعلاج فرط التعرق. الآثار الجانبية عادةً ما تكون طفيفة، مثل كدمات خفيفة أو ألم مؤقت في موقع الحقن."
                },
                {
                    "question": "كم تستغرق جلسة العلاج؟",
                    "answer": "يستغرق إجراء بوتوكس تحت الإبط عادةً حوالي 15 إلى 20 دقيقة، ويتضمن عدة حقن صغيرة في كل إبط."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "تستمر تأثيرات بوتوكس تحت الإبط عادةً من 4 إلى 6 أشهر. بعد ذلك، يمكن تحديد مواعيد جلسات متابعة للحفاظ على النتائج."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "الحقن تكون مريحة بشكل عام، مع حد أدنى من الألم المحتمل. بعض المرضى يشبهون الإحساس بوخزة خفيفة. يمكن استخدام كريم مخدر أو كمادات الثلج قبل العلاج لزيادة الراحة أثناء الإجراء."
                },
                {
                    "question": "هل أحتاج إلى فترة راحة بعد العلاج؟",
                    "answer": "لا يتطلب بوتوكس تحت الإبط فترة تعافي، حيث يمكنك استئناف أنشطتك اليومية فورًا بعد الإجراء، ولكن قد يُنصح بتجنب النشاط البدني المكثف لمدة 24 ساعة."
                },
                {
                    "question": "ما تكلفة بوتوكس تحت الإبط؟",
                    "answer": "تختلف التكلفة وفقًا للعيادة والكمية البوتوكس المناسبة للعلاج. من الأفضل استشارة المختص للحصول على تقدير دقيق للتكلفة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};